import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApplicationRoutes } from '@foxera/shared/constants/application.routes';
import { TenantService } from '@foxera/feature/tenant/services/tenant.service';

export const canActivateTenant: CanActivateFn = () => {
  const tenantService = inject(TenantService);
  const router = inject(Router);

  const selectedTenant = tenantService.getSelectedTenantFromStorage();

  if (!selectedTenant) {
    // No tenant selected, redirect to tenant selection
    router.navigate([ApplicationRoutes.TENANT_SELECTION]);
    return false;
  }

  return true;
};
